import { render, staticRenderFns } from "./DependentListPage.vue?vue&type=template&id=49ba4c22"
import script from "./DependentListPage.vue?vue&type=script&lang=js"
export * from "./DependentListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports